import Order from '@/classes/procedure_executions/Order'
import AcceptInvite from '@/classes/procedure_executions/AcceptInvite'
import Recaptcha from '@/classes/procedure_executions/Recaptcha'
import Transaction from '@/classes/transactions/Transaction'
import Project from '@/classes/projects/Project'
import Benefiting from '@/classes/benefitings/Benefiting'

export default class ActionsData {
  constructor ({ transaction = {}, order, project = {}, accept_invite = {}, fee = {}, create_invite = {}, recaptcha = {}, benefiting = {} } = {}) {
    this.transaction = new Transaction(transaction)
    this.order = new Order(order)
    this.project = new Project(project)
    this.accept_invite = new AcceptInvite(accept_invite)
    this.fee = fee
    this.create_invite = create_invite
    this.recaptcha = new Recaptcha(recaptcha)
    this.benefiting = new Benefiting(benefiting)
  }

  get to_database () {
    return {
      ...this,
      benefiting: this.benefiting.to_database,
      transaction: this.transaction.to_database,
      project: this.project.to_database
    }
  }

  get to_tamaro () {
    return {
      ...this.benefiting.to_tamaro,
      ...this.transaction.to_tamaro
    }
  }

  get to_tamaro_automation () {
    return {
      ...this.benefiting.to_tamaro_automation
    }
  }
}
